// src/Components/FAQ.js
import React from 'react';
import { Collapse } from 'antd';
import { Typography } from 'antd';
import '../App.css';

const { Panel } = Collapse;
const { Title } = Typography;

const FAQ = () => {
  return (
    <div id="faq" className="faq-section">
      <Title level={2} className="faq-title">Frequently Asked Questions</Title>
      <Collapse accordion>
        <Panel header="How is ChronoFlow different from LinkedIn Recruiter or a job board?" key="1">
          <p>LinkedIn and job boards charge you to search fresh every time a role opens. ChronoFlow keeps every candidate who applies or gets invited in a pool you own permanently, so the more you hire over time, the less searching each new role requires.</p>
        </Panel>
        <Panel header="How does AI screening work, and do I need to set it up?" key="2">
          <p>For each job, the recruiter defines the screening criteria — required skills, minimum experience, education level, location preference — and sets the weight of each factor. Once that's done, every application that comes in is automatically scored against those criteria. You open the platform to a ranked list, not a pile of unread CVs. The criteria are per-job, so different roles can be screened differently without any extra work.</p>
        </Panel>
        <Panel header="Does the talent pool require manual data entry?" key="3">
          <p>No. Candidates are added to your talent pool automatically when they apply or accept an invite — there's no import process. When a candidate in your pool updates their profile (job search status, location, work preferences), you get an in-app notification straight away. The pool stays current without you doing anything.</p>
        </Panel>
        <Panel header="How does the recruiter-to-hiring manager handoff work?" key="4">
          <p>When you're ready to submit a candidate to your hiring manager, you pick which parts of their profile to share (contact info, resume, AI score, screening answers, your private notes) and submit with one click. The hiring manager gets a curated smart profile in their own dashboard — with an AI-generated summary of the candidate's background — and can give feedback or message you directly inside the platform.</p>
        </Panel>
        <Panel header="Is there a free trial and do I need a credit card?" key="5">
          <p>Yes — ChronoFlow offers a 7-day free trial with no credit card required. You can post jobs, invite candidates, run AI screening, and explore the full platform before committing to any plan.</p>
        </Panel>
      </Collapse>
    </div>
  );
};

export default FAQ;
